var map = {
	"./age.png": 44738,
	"./apoinment/clock.png": 79330,
	"./apoinment/date.png": 91649,
	"./area.png": 19494,
	"./avt.png": 14482,
	"./city.png": 77216,
	"./country.png": 55162,
	"./drop.png": 67969,
	"./email.png": 58816,
	"./inject.png": 67255,
	"./lock.png": 63197,
	"./married.png": 78946,
	"./name.png": 19087,
	"./password.png": 65035,
	"./phone.png": 74046,
	"./pincode.png": 75602,
	"./reminder/DASHBOARD.png": 98216,
	"./reminder/EM.png": 90962,
	"./reminder/PC.png": 28139,
	"./reminder/SMS.png": 80045,
	"./reminder/WP.png": 71427,
	"./school.png": 95243,
	"./source.png": 63372,
	"./state.png": 78539,
	"./status/apple.png": 98456,
	"./status/apple_sel.png": 18912,
	"./status/clinic.png": 14521,
	"./status/clinic_sel.png": 98795,
	"./status/preganancy.png": 60954,
	"./status/preganancy_sel.png": 39753,
	"./status/whatsapp.png": 74496,
	"./status/whatsapp_sel.png": 23812,
	"./tag.png": 32343,
	"./translate.png": 13855,
	"./user.png": 68183,
	"./whatsapp.png": 62721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25587;